/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  DcaAllocationConfigHistoryResponse,
  GetDcaAllocationConfigHistoryParams,
  GetDcaAllocationConfigResponse,
  UpdateDcaAllocationConfigParams,
  UpdateDcaAllocationConfigRequest,
  UpdateDcaAllocationConfigResponse,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * SO-32233: no debt-management permission check is enforced yet - authenticated callers only. Feeds the NOVA config webpage - returns every row, including zero-percentage (retired-but-present) dcas, across all occupier/accountState/placementNumber segments. No filtering.
 * @summary Get the entire DCA allocation config table, unfiltered.
 */
export const getDcaAllocationConfig = (
  options?: SecondParameter<
    typeof backofficeRequest<GetDcaAllocationConfigResponse>
  >,
) => {
  return backofficeRequest<GetDcaAllocationConfigResponse>(
    { url: `/api/v1/dca-allocation-config`, method: "GET" },
    options,
  )
}
/**
 * Upsert: if no rows exist for the given occupier/accountState/placementNumber the placement is created, otherwise its allocations are replaced wholesale.
 *
 * SO-32233: no debt-management permission check is enforced yet - authenticated callers only. Out of scope: setting up new DCAs, changing segment definitions.
 * @summary Replace the DCA allocation percentages for a segment + placement.
 */
export const updateDcaAllocationConfig = (
  updateDcaAllocationConfigRequest: UpdateDcaAllocationConfigRequest,
  params: UpdateDcaAllocationConfigParams,
  options?: SecondParameter<
    typeof backofficeRequest<UpdateDcaAllocationConfigResponse>
  >,
) => {
  return backofficeRequest<UpdateDcaAllocationConfigResponse>(
    {
      url: `/api/v1/dca-allocation-config`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateDcaAllocationConfigRequest,
      params,
    },
    options,
  )
}
/**
 * SO-32338: the config table holds current state only and each save replaces it wholesale, so this is the only record of what a change replaced.
 *
 * One entry per agency per save. Entries sharing a changeId are one save and cover the union of the split before and after it: previousPercentage is absent where the agency was added, newPercentage is absent where it was removed, and both are present where only the percentage moved. An agency left untouched by a save still gets an entry, so a change can be read on its own without replaying the ones before it.
 *
 * changedBy is absent on the seeded starting state, which no user made. A cell that has never been configured returns an empty list rather than a 404.
 *
 * No debt-management permission check is enforced yet - authenticated callers only.
 * @summary Every recorded change to one segment and placement, newest first.
 */
export const getDcaAllocationConfigHistory = (
  params: GetDcaAllocationConfigHistoryParams,
  options?: SecondParameter<
    typeof backofficeRequest<DcaAllocationConfigHistoryResponse>
  >,
) => {
  return backofficeRequest<DcaAllocationConfigHistoryResponse>(
    { url: `/api/v1/dca-allocation-config/history`, method: "GET", params },
    options,
  )
}
export type GetDcaAllocationConfigResult = NonNullable<
  Awaited<ReturnType<typeof getDcaAllocationConfig>>
>
export type UpdateDcaAllocationConfigResult = NonNullable<
  Awaited<ReturnType<typeof updateDcaAllocationConfig>>
>
export type GetDcaAllocationConfigHistoryResult = NonNullable<
  Awaited<ReturnType<typeof getDcaAllocationConfigHistory>>
>
